import React, { useState } from 'react';
import { Card, Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDrag } from 'react-dnd';
import { useDPPState } from '../Context/index';

function SectionControl() {
  const { dppState } = useDPPState();
  const { t } = useTranslation('common');
  const { controlsOption, controlPanelOpen } = dppState;
  const [forActiveClass, setForActiveClass] = useState([]);

  function MovableItem({ ele }) {
    const [{ isDragging }, drag] = useDrag({
      type: ele?.type,
      item: { ...ele },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });
    const opacity = isDragging ? 0.5 : 1;
    return (
      <div ref={drag} style={{ opacity }} key={ele.id}>
        {ele?.label}
      </div>
    );
  }

  const forActivekey = (e) => {
    if (forActiveClass?.includes(e?.target?.name)) {
      const nameArray = [...forActiveClass];
      const changedArray = nameArray.filter((ele) => {
        return ele !== e?.target?.name;
      });
      setForActiveClass([...changedArray]);
    } else {
      const nameArray = [...forActiveClass];
      nameArray.push(e?.target?.name);
      setForActiveClass([...nameArray]);
    }
  };

  return (
    <div className={`${controlPanelOpen ? 'menu-open' : ''} left-section`}>
      <div className="move-cursor">
        <Accordion defaultActiveKey="1">
          <Card className="border-0 rounded-0">
            <Accordion.Toggle
              variant="link"
              eventKey="1"
              name="OutherControls"
              onClick={(e) => {
                forActivekey(e);
              }}
              className="d-flex btn-custom-module-tab text-center active"
            >
              {t('CUSTOM_MODULES.LIBRARY.SECTION_CONTROL.OTHER_CONTROL')}
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <ul className="control-ul" style={{ listStyle: 'none' }}>
                {controlsOption?.map((item) => {
                  return item?.components?.map((ele) => {
                    return (
                      <li key={`${ele?.id}`}>
                        <MovableItem ele={ele} />
                      </li>
                    );
                  });
                })}
              </ul>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    </div>
  );
}
export default SectionControl;
